import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ApiService} from "~/app/core/api.service";
import {NavigationService} from "~/app/core/navigation.service";
import {BasePage} from "~/app/pages/base.page";
import * as Log from "~/app/core/log";

@Component({
    selector: "Logout",
    templateUrl: "./logout.page.html",
    styleUrls: ["./logout.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutPage extends BasePage implements OnInit, AfterViewInit {
    offerId: number = null;
    autoOpen: boolean = null;

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly api: ApiService,
        private readonly nav: NavigationService
    ) {
        super();
    }

    ngOnInit(): void {
        this.api.user_logout();
        this.api.offers_clearSearchResults();
        this.nav.navPageSearching(this.api);
    }

    ngAfterViewInit(): void {
        // TODO why does this get called twice?
        Log.debug(Log.Tag.SearchingPage, "End searching.");
        this.waiting = false;
        this.waitingSpinning = false;
        this.cd.markForCheck();
    }
}
